// extracted by mini-css-extract-plugin
export default {"root":"EmployedItem_root__ECg33","rootCustomer":"EmployedItem_rootCustomer__w3bVt","test":"EmployedItem_test__I88vn","nameCell":"EmployedItem_nameCell__CBsQY"};